<template>
  <scroll-bar>
    <div class="userInfoContain">
      <img :src="userInfo.u_avatar" class="head" @click="toHome()" />
      <div class="nameContain">
        <p class="userName">{{ userInfo.u_nickname }}</p>
        <img :src="badgeUrl" class="badgeIcon" v-if="badgeUrl" />
      </div>
      <div class="levelContain">
        <div class="levelLabelContain">
          <div class="levelLabel">当前创作等级</div>
          <div class="levelLabel">当前创作分</div>
        </div>
        <div class="levelNumContain">
          <div class="levelNum">Lv{{ userScore.user_level }}</div>
          <div class="levelNum">{{ userScore.user_score }}</div>
        </div>
      </div>
      <div class="lineLabelContain">
        <div class="lineLabel">创作者成长</div>
        <div class="moreRightContain" @click="toRights()">
          <div class="moreRightText">解锁更多权益</div>
          <img src="../../../assets/new/gengduo 10@2x.png" class="moreRightIcon" />
        </div>
      </div>
      <div class="nextLevelContain">
        <div class="nextLevelLine" :style="{ width: redLineWidth + 'px' }"></div>
        <div class="dotLeft"></div>
        <div class="dotRight" :class="{ dotRightRed: userScore.user_level >= 5 }"></div>
      </div>
      <div class="nextLevelTextContain" v-if="userScore.user_level < 5">
        <div class="nextLevelText">
          （还需{{ (userScore.next_need_score - userScore.user_score).toFixed(2) }}分升至Lv{{
            userScore.user_level + 1
          }}）
        </div>
        <div class="nextLevelRadio">
          {{ (userScore.user_score - userScore.need_score).toFixed(2) }}<span class="nextLevelNum">/{{
            userScore.next_need_score - userScore.need_score }}</span>
        </div>
      </div>
    </div>
    <el-popover placement="right" width="460" trigger="hover" class="writeContain">
      <div class="indexTypeList">
        <div class="typeItem" v-for="(item, index) in typeList" :key="index" @click="toAdd(item.index)">
          <img :src="item.icon" class="typeIcon" />
          <div class="typeName">{{ item.name }}</div>
        </div>
      </div>
      <el-button size="mini" type="primary" class="toWriteContain" @click="toAdd(1)" slot="reference">
        <img src="../../../assets/new/chuangzuo@2x.png" class="icon" />
        <p>内容创作</p>
      </el-button>
    </el-popover>
    <el-menu :default-active="activeIndex" :show-timeout="200" mode="vertical" text-color="#333333" unique-opened
      :default-openeds="openeds$">
      <template v-for="item in asideMenuConfig">
        <!-- 如果只有一级菜单 -->
        <router-link v-if="!item.children.length && item.openType == 'new'" :to="item.ap_url" :key="item.ap_name"
          tag="a" target="_blank">
          <el-menu-item :index="item.ap_url" :disabled="true">
            <img :src="item.activeIcon" class="newIcon" v-if="activeIndex == item.ap_url" />
            <img :src="item.icon" class="newIcon" v-else />
            <span v-if="item.ap_name" slot="title">{{ item.ap_name }}</span>
          </el-menu-item>
        </router-link>
        <router-link v-else-if="!item.children.length && item.openType != 'new'" :to="item.ap_url" :key="item.ap_name">
          <el-menu-item :index="item.ap_url">
            <img :src="item.activeIcon" class="newIcon" v-if="activeIndex == item.ap_url" />
            <img :src="item.icon" class="newIcon" v-else />
            <span v-if="item.ap_name" slot="title">{{ item.ap_name }}</span>
          </el-menu-item>
        </router-link>

        <!-- 如果有二级菜单 -->
        <el-submenu v-else :index="item.ap_name || item.ap_url" :key="item.name">
          <template slot="title">
            <img :src="item.activeIcon" class="newIcon"
              v-if="item.children.some((child) => child.ap_url === activeIndex)" />
            <img :src="item.icon" class="newIcon" v-else />
            <span v-if="item && item.ap_name" slot="title" :class="{
              activeText: item.children.some(
                (child) => child.ap_url === activeIndex
              ),
            }">{{ item.ap_name }}</span>
          </template>

          <!-- 二级路由的设置，根据数据判断是否要加新页面的打开操作 -->
          <template v-for="child in item.children">
            <router-link v-if="!child.children.length && !child.tag" :to="item.ap_url + child.ap_url"
              :key="child.ap_name">
              <el-menu-item :index="item.ap_url + child.ap_url">
                <span v-if="child && child.ap_name" slot="title">{{
                  child.ap_name
                }}</span>
              </el-menu-item>
            </router-link>

            <!-- 如果有tag，说明需要新打开页面-->
            <a v-if="!child.children.length && child.tag" :href="'#' + item.ap_url + child.ap_url" :key="child.ap_name"
              target="_blank" class="el-menu-item">
              <span v-if="child && child.ap_name" slot="title" @click.stop="handleTag(child.ap_url)">{{ child.ap_name
              }}</span>
            </a>

            <!-- 如果有三级菜单了，到这里来处理 -->
            <el-submenu v-if="
              child.children &&
              child.children.length &&
              child.children.length > 0
            " :index="child.ap_name || child.ap_url" :key="child.name">
              <template slot="title">
                <i v-if="child != '1' && child.ap_icon" :class="child.ap_icon" />
                <span v-if="child && child.ap_name" slot="title">{{
                  child.ap_name
                }}</span>
              </template>
              <template v-for="subChild in child.children">
                <router-link :to="item.ap_url + child.ap_url + subChild.ap_url" :key="subChild.ap_name">
                  <el-menu-item :index="item.ap_url + child.ap_url + subChild.ap_url">
                    <span v-if="subChild && subChild.ap_name" slot="title">{{
                      subChild.ap_name
                    }}</span>
                  </el-menu-item>
                </router-link>
              </template>
            </el-submenu>
          </template>
        </el-submenu>
      </template>
    </el-menu>

    <el-dialog title="请完成实名认证" :visible.sync="certificationVisible" class="certificationInfoContainer" width="1026px">
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode" />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img src="../../../assets/shiming@2x.png" class="app" v-if="u_cert != 1" />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>

    <BanDialog ref="banShow" :isShow="isBanned" :allowClose="true" @closeBan="isBanned = false"></BanDialog>

    <div class="toolContain">
      <div class="upBtn" @click="toTop()">
        <img src="../../../assets/new/up.png" class="upIcon" />
      </div>
      <div class="serviceBtn" @click="showService = true">
        <img src="../../../assets/service.png" class="serviceIcon" />
      </div>
    </div>

    <el-dialog :visible.sync="showService" top="5vh" :center="true" width="350px">
      <iframe :src="`https://cs.topnews.cn/#/welcome?uid=${userInfo.u_id}&nickname=${userInfo.u_nickname}`"
        style="height: 80vh" />
    </el-dialog>
  </scroll-bar>
</template>

<script>
import ScrollBar from "./ScrollBar";
import { mapGetters } from "vuex";
import { isCreation$ } from "@/utils/store-rx.js";
import { dispatch } from "frer";
import tools from "@/utils/tools.js";
import { BehaviorSubject } from "rxjs";
import { USER_HOST, SWNEWS_HOST, NEWS_HOST } from "../../../constants/apiHosts";
import BanDialog from "../../../components/banDialog.vue";

export default {
  name: "SideBar",
  components: {
    ScrollBar,
    BanDialog,
  },
  data() {
    return {
      asideMenuConfig: [
        {
          ap_name: "首页",
          ap_url: "/index",
          ap_icon: "el-icon-s-home",
          ap_sort: 1,
          children: [],
          icon: "https://img.dingxinwen.cn/image/20260409/c15676dd980ebac46dd9c59832d08f63.png",
          activeIcon:
            "https://img.dingxinwen.cn/image/20260409/940699c310d6d6b4c811463bbba50e1c.png",
        },
        {
          ap_name: "内容管理",
          ap_url: "",
          ap_icon: "el-icon-s-order",
          ap_sort: 2,
          children: [
            {
              ap_name: "作品管理",
              ap_url: "/personalScript",
              ap_sort: 1,
              children: [],
            },
            {
              ap_name: "评论管理",
              ap_url: "/comments",
              ap_sort: 2,
              children: [],
            },
            {
              ap_name: "草稿库",
              ap_url: "/draft",
              ap_sort: 3,
              children: [],
            },
            {
              ap_name: "素材管理",
              ap_url: "/material",
              ap_sort: 5,
              children: [],
            },
          ],
          icon: "https://img.dingxinwen.cn/image/20260409/c5823b77420ab08458acf4ab97ef078e.png",
          activeIcon:
            "https://img.dingxinwen.cn/image/20260409/1fd0f121b873713f7bbbf0155da45f94.png",
        },
        {
          ap_name: "创作成长",
          ap_url: "",
          ap_icon: "el-icon-s-custom",
          ap_sort: 3,
          children: [
            {
              ap_name: "权益中心",
              ap_url: "/rights",
              ap_icon: "",
              ap_sort: 1,
              children: [],
            },
            {
              ap_name: "榜单",
              ap_url: "/rank",
              ap_icon: "",
              ap_sort: 2,
              children: [],
              openType: "new",
              tag: "new",
            },

            {
              ap_name: "政务号",
              ap_url: "/govAffairs",
              ap_icon: "",
              ap_sort: 3,
              children: [],
            },
            {
              ap_name: "企业号",
              ap_url: "/enterprise",
              ap_icon: "",
              ap_sort: 4,
              children: [],
            },
          ],
          icon: "https://img.dingxinwen.cn/image/20260409/a57a8a88efab92f75a418fde5c80c7ae.png",
          activeIcon:
            "https://img.dingxinwen.cn/image/20260409/3f512cc688644f6ca2b7fd50fb11f025.png",
        },
        {
          ap_name: "帮助中心",
          ap_url: "/helpCenter",
          ap_icon: "el-icon-question",
          ap_sort: 4,
          children: [],
          icon: "https://img.dingxinwen.cn/image/20260409/7e6e65afd1f83aa84523e29e119e0932.png",
          activeIcon:
            "https://img.dingxinwen.cn/image/20260409/34be32957252538cbbf0825d8b7ab492.png",
        },
        {
          ap_name: "设置",
          ap_url: "/user",
          ap_icon: "el-icon-s-tools",
          ap_sort: 5,
          children: [],
          icon: "https://img.dingxinwen.cn/image/20260409/c774cd9423b74442ceb696d1146212c6.png",
          activeIcon:
            "https://img.dingxinwen.cn/image/20260409/5a4c866129170c5a5726a62151506ae0.png",
        },
      ],
      certificationVisible: false,
      u_cert_status: 0,
      u_cert: 0,
      isBanned: false,
      userInfo: {},
      badgeUrl: "",
      showService: false,
      typeList: [
        {
          name: "发布文章",
          icon: require("../../../assets/new/pub0.png"),
          index: 1,
        },
        {
          name: "发布视频",
          icon: require("../../../assets/new/pub1.png"),
          index: 2,
        },
        {
          name: "发布帖子",
          icon: require("../../../assets/new/pub3.png"),
          index: 6,
        },
        {
          name: "发布图集",
          icon: require("../../../assets/new/pub2.png"),
          index: 3,
        },
      ],
      userScore: {},
      growUp: {},
      redLineWidth: 0,
    };
  },
  computed: {
    ...mapGetters(["activeIndex", "menuFresh"]),
  },
  subscriptions() {
    return {
      openeds$: new BehaviorSubject([]),
    };
  },
  watch: {
    menuFresh(newVal) {
      if (newVal) {
        this.$store.state.common.menuFresh = false;
      }
    },
  },
  created() {
    this.u_cert_status = localStorage.getItem("u_cert_status");
    this.u_cert = localStorage.getItem("u_cert");

    setTimeout(() => {
      this.u_cert_status = localStorage.getItem("u_cert_status");
      this.u_cert = localStorage.getItem("u_cert");
    }, 3000);

    this.getUserInfo();
    this.getUserWearBadge();
    //this.getShortPlay();
    this.getUserScore();
  },
  mounted() { },
  methods: {
    handleTag(item) {
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }

      if (this.u_cert != 1) {
        this.certificationVisible = true;
      } else if (
        item.ap_name.indexOf("创作") >= 0 &&
        banData.ban_type == 1 &&
        banData.ban_range_type.indexOf("1") > -1
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
      } else {
        let routeData = this.$router.resolve({
          path: item.ap_url,
        });
        window.open(routeData.href, "_blank");
      }
    },
    jumpToMain() {
      this.$router.push({
        path: "/personalScript",
      });
    },
    getUserInfo() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/user/mpBaseUserinfo`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.userInfo = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getUserWearBadge() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/userBadge/getUserWearBadge`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.badgeUrl = res.data.data.cover_url || "";
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getShortPlay() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/microDrama/isHasAuth`, {})
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.check) {
              this.asideMenuConfig.forEach((item) => {
                if (item.ap_name == "内容管理") {
                  item.children.splice(3, 0, {
                    ap_name: "短剧",
                    ap_url: "/shortPlay",
                    ap_sort: 4,
                    children: [],
                  });
                }
              });
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toAdd(type) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (
        banData.ban_type == 1 &&
        ((type != 6 && banData.ban_range_type.indexOf("1") > -1) ||
          (type == 6 && banData.ban_range_type.indexOf("3") > -1))
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }

      if (type == 1) {
        //往写稿跳转
        let routeData = this.$router.resolve({
          path: "/scriptWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 2) {
        //往视频跳转
        let routeData = this.$router.resolve({
          path: "/videoWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 3) {
        //往图集跳转
        let routeData = this.$router.resolve({
          path: "/graphWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 4) {
        //往合集跳转
        let routeData = this.$router.resolve({
          path: "/videoWrite?isPack=1",
        });
        window.open(routeData.href, "_blank");
      } else if (type == 6) {
        //往帖子跳转
        let routeData = this.$router.resolve({
          path: "/post",
        });
        window.open(routeData.href, "_blank");
      }
    },
    getUserScore() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/creatorScore/getUserScore`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.userScore = res.data.data;

            if (this.userScore.user_level >= 5) {
              this.redLineWidth = 173;
            } else {
              this.redLineWidth =
                ((this.userScore.user_score - this.userScore.need_score) /
                  (this.userScore.next_need_score -
                    this.userScore.need_score)) *
                142 +
                24;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toRights() {
      this.$router.push({
        path: "/rights",
      });
    },
    toHome() {
      window.open(`https://www.topnews.cn/home/${this.userInfo.u_id}`);
    },
    toTop() {
      const content = document.querySelector(".content");
      if (content) {
        content.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      const content1 = document.querySelector(".el-tabs__content");
      if (content1) {
        content1.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      const content2 = document.querySelector(".scriptContain");
      if (content2) {
        content2.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  transition: width 0.28s;
  width: 198px !important;
  z-index: 1001;
  overflow-x: hidden;
  background-color: #edf1f8;
  height: calc(100vh - 100px);
  overflow-y: scroll;

  .userInfoContain {
    border-radius: 8px 8px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 0 0 0;

    .head {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      cursor: pointer;
    }

    .nameContain {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 8px;

      .userName {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 600;
        line-height: 30px;
      }

      .badgeIcon {
        width: 24px;
        height: 24px;
        margin-left: 4px;
      }
    }

    .levelContain {
      width: 100%;
      padding-top: 19px;

      .levelLabelContain {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
        display: flex;
        justify-content: space-between;
      }

      .levelNumContain {
        color: #f32432;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        padding-top: 2px;
        display: flex;
        justify-content: space-between;
      }
    }

    .lineLabelContain {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-top: 16px;

      .lineLabel {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
      }

      .moreRightContain {
        display: flex;
        align-items: center;
        cursor: pointer;

        .moreRightText {
          color: #666666;
          font-family: "PingFang SC";
          font-size: 10px;
          font-weight: 400;
        }

        .moreRightIcon {
          height: 12px;
          margin-left: 2px;
        }
      }
    }

    .nextLevelContain {
      width: 198px;
      height: 6px;
      border-radius: 6px;
      margin-top: 13px;
      background: linear-gradient(90deg,
          #fff 60.62%,
          #ffffffb3 88.19%,
          #edf1f8 100%);
      position: relative;

      .nextLevelLine {
        height: 6px;
        border-radius: 6px;
        background: linear-gradient(90deg,
            #edf1f8 0%,
            #f32432b3 30%,
            #d7000f 100%);
      }

      .dotLeft {
        width: 6px;
        height: 6px;
        border-radius: 6px;
        border: 1px solid #fff;
        background: #f32432;
        position: absolute;
        left: 18px;
        top: 0;
      }

      .dotRight {
        width: 6px;
        height: 6px;
        border-radius: 6px;
        border: 1px solid #fff;
        background: #dadada;
        position: absolute;
        right: 26px;
        top: 0;
      }

      .dotRightRed {
        background: #f32432;
      }
    }

    .nextLevelTextContain {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 9px;

      .nextLevelText {
        color: #999999;
        font-family: "PingFang SC";
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
      }

      .nextLevelRadio {
        color: #f32432;
        font-family: "PingFang SC";
        font-size: 10px;
        font-weight: 500;

        .nextLevelNum {
          font-size: 8px;
        }
      }
    }
  }

  .writeContain {
    width: 100%;
    margin-top: 32px;
    display: block;

    .toWriteContain {
      width: 100%;
      border-radius: 6px;

      /deep/span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 20px;

        .icon {
          height: 20px;
          margin-right: 4px;
        }
      }
    }
  }

  a {
    display: inline-block;
    width: 100%;
  }

  /deep/.el-menu {
    width: 100% !important;
    border: none;
    border-radius: 0 0 8px 8px;
    background: #edf1f8 !important;
    padding: 20px 0 0 0;

    .newIcon {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }

    .el-submenu__icon-arrow {
      font-size: 15px;
      font-weight: bold;
    }

    .el-submenu__title {
      height: 52px;
      line-height: 52px;

      span {
        font-size: 16px;
        font-weight: 400;
      }

      .activeText {
        color: #f32432;
      }
    }

    /deep/.el-submenu__title:hover {
      background-color: #ffe6e69e !important;
    }

    .el-menu-item {
      font-size: 16px;
      font-weight: 400;
      width: 100%;
      min-width: unset;
      border-radius: 6px;
      margin: 3px 0;
      display: flex;
      align-items: center;
      height: 46px;
    }

    .el-menu-item.is-active {
      background: #ffe6e69e !important;
      color: #f32432;
    }

    .el-menu-item:hover {
      background: #ffe6e69e !important;
      color: #f32432;
    }

    .el-menu-item.is-disabled {
      opacity: 1;
      cursor: pointer;
    }

    // 子菜单下的样式
    .el-menu--inline {
      padding: 0;

      .el-menu-item {
        font-size: 14px;
        color: #333 !important;
        padding-left: 50px !important;
      }

      .el-menu-item.is-active {
        background: #ffe6e69e !important;
        color: #f32432 !important;
      }

      .el-menu-item:hover {
        background: #ffe6e69e !important;
        color: #f32432 !important;
      }
    }

    /deep/.createList {
      padding-left: 0 !important;
      padding-right: 0 !important;

      .el-menu-item {
        padding: 0 !important;
      }

      span {
        width: 100%;
        height: 100%;
        display: block;
        padding-left: 40px;
      }
    }
  }

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }

  .toolContain {
    position: fixed;
    right: 30px;
    bottom: 20px;
    z-index: 10;

    .serviceBtn {
      width: 48px;
      height: 48px;
      border-radius: 4px;
      background: #fff;
      padding: 11px;
      cursor: pointer;
      box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.12);

      .serviceIcon {
        width: 26px;
      }
    }

    .upBtn {
      width: 48px;
      height: 48px;
      border-radius: 4px;
      background: #fff;
      cursor: pointer;
      box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.12);
      margin-bottom: 9px;

      .upIcon {
        width: 48px;
      }
    }
  }
}
</style>
